import React, { Component } from 'react';
import { connect } from 'react-redux';

import { KeyLicenseTypes } from '../common/keyLicenseTypes';
import ConfirmDialog from '../components/confirmDialog';
import * as permanentLicensesActions from '../store/permanentLicensesSlice';
import { permanentLicensesSelectors } from '../store/permanentLicensesSlice';
import * as offlineLicensesActions from '../store/offlineLicensesSlice';
import { offlineLicensesSelectors } from '../store/offlineLicensesSlice';
import { showModalMessage } from '../store/modalsSlice';
import { unwrapResult } from '@reduxjs/toolkit';

const Mode = {
  Remove: 0,
  Restore: 1
};

class RemoveRestoreLicsConfirmDialog extends Component {

  static get Mode() {
    return Mode;
  }

  constructor(props) {
    super(props);
    this.onConfirm = this.onConfirm.bind(this);
  }

  onConfirm() {
    let processor = null;
    if (this.props.mode === Mode.Remove)
      processor = this.props.removeLics[this.props.licenseType];
    else if (this.props.mode === Mode.Restore)
      processor = this.props.restoreLics[this.props.licenseType];

    if (processor !== null) {
      processor(this.props.licenseIds).then(unwrapResult).catch(() => {
        this.props.showModalMessage("Error", this.props.error[this.props.licenseType].toString());
      });
    }
    this.props.onClose();
  }

  render() {
    let qoperation = null;
    let toperation = null;
    if (this.props.mode === Mode.Remove) {
      qoperation = "remove";
      toperation = "removing";
    } else if (this.props.mode === Mode.Restore) {
      qoperation = "restore";
      toperation = "restoring";
    }
    else
      return null;

    let c = this.props.licenseIds.length;
    let question = <React.Fragment>
      {`Are you sure want to ${qoperation} `}
      {c > 1 ? <strong>{c} </strong> : ""}
      {`selected license${c > 1 ? "s" : ""}?`}
      </React.Fragment>;
    return (
      <ConfirmDialog
        show={this.props.show}
        onClose={this.props.onClose}
        title={`Licenses ${toperation}`}
        question={question}
        onConfirm={this.onConfirm}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  error: {
    [KeyLicenseTypes.OnlinePermanent]: permanentLicensesSelectors.removingRestoringError(state),
    [KeyLicenseTypes.Offline]: offlineLicensesSelectors.removingRestoringError(state),
  }
});

const mapDispatchToProps = (dispatch) => ({
  removeLics: {
    [KeyLicenseTypes.OnlinePermanent]: (licenseIds) => dispatch(permanentLicensesActions.remove({ licenseIds })),
    [KeyLicenseTypes.Offline]: (licenseIds) => dispatch(offlineLicensesActions.remove({ licenseIds }))
  },
  restoreLics: {
    [KeyLicenseTypes.OnlinePermanent]: (licenseIds) => dispatch(permanentLicensesActions.restore({ licenseIds })),
    [KeyLicenseTypes.Offline]: (licenseIds) => dispatch(offlineLicensesActions.restore({ licenseIds }))
  },
  showModalMessage: (title, text) => dispatch(showModalMessage({ title, text })),
});

export default connect(mapStateToProps, mapDispatchToProps)(RemoveRestoreLicsConfirmDialog);



// WEBPACK FOOTER //
// ./src/containers/removeRestoreLicsConfirmDialog.js